













































export default {
  props: {
    header: {
      default: '',
      type: String,
    },
     subText: {
      default: '',
      type: String,
    },
      subHeader: {
      default: '',
      type: String,
    },
     subBody: {
      default: '',
      type: String,
    },
    body: {
      default: '',
      type: String,
    },
    okText: {
      default: 'Ok',
      type: String,
    },
    cancelText: {
      default: 'Cancel',
      type: String,
    },
   hideCancelButton:{
     default: false,
      type: Boolean,
   },
    hideOkButton:{
     default: false,
      type: Boolean,
   },
   paragraph:{
      default: '',
      type: String,
   },
    onOk: {
      default: () => {},
      type: Function,
    },
    onCancel: {
      default: () => {},
      type: Function,
    },
    okBtnClass: {
      default: '',
      type: String,
    },
    channel: {
      type: String,
      required: true,
    },
  },
  methods : {
    formattedChannel(channel) {
      const map = {
        sms: 'SMS',
        whatsapp: 'WhatsApp',
      };
      return map[channel]
    }
  }
};
